export default {
    AGUARDANDO_HOMOLOGACAO: 'Aguard. Homologação',
    HOMOLOGADO: 'Homologado',
    DEVOLVIDO: 'Devolvido',
    ANALISANDO: 'Analisando'
}